import React from "react";
import Icon from "components/AppIcon";

const OrderBook = ({ stock }) => {
  if (!stock) return (
    <div className="flex flex-col items-center justify-center h-48 text-muted-foreground gap-2">
      <Icon name="BookOpen" size={32} color="var(--color-muted-foreground)" />
      <span className="font-caption text-sm">Select a stock to view order book</span>
    </div>
  );

  const asks = [
    { price: stock?.price * 1.012, qty: 340, total: 340 * stock?.price * 1.012 },
    { price: stock?.price * 1.009, qty: 210, total: 210 * stock?.price * 1.009 },
    { price: stock?.price * 1.006, qty: 580, total: 580 * stock?.price * 1.006 },
    { price: stock?.price * 1.003, qty: 120, total: 120 * stock?.price * 1.003 },
    { price: stock?.price * 1.001, qty: 890, total: 890 * stock?.price * 1.001 },
  ];
  const bids = [
    { price: stock?.price * 0.999, qty: 760, total: 760 * stock?.price * 0.999 },
    { price: stock?.price * 0.997, qty: 430, total: 430 * stock?.price * 0.997 },
    { price: stock?.price * 0.994, qty: 290, total: 290 * stock?.price * 0.994 },
    { price: stock?.price * 0.991, qty: 650, total: 650 * stock?.price * 0.991 },
    { price: stock?.price * 0.988, qty: 180, total: 180 * stock?.price * 0.988 },
  ];

  const maxTotal = Math.max(...asks?.map(a => a?.total), ...bids?.map(b => b?.total));

  return (
    <div className="p-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="BookOpen" size={16} color="var(--color-primary)" />
        <span className="font-heading text-sm font-semibold text-foreground">Order Book</span>
        <span className="font-caption text-xs text-muted-foreground ml-auto">{stock?.ticker}</span>
      </div>
      {/* Header */}
      <div className="grid grid-cols-3 gap-2 mb-2 px-1">
        <span className="font-caption text-xs text-muted-foreground">Price</span>
        <span className="font-caption text-xs text-muted-foreground text-right">Qty</span>
        <span className="font-caption text-xs text-muted-foreground text-right">Total</span>
      </div>
      {/* Asks */}
      <div className="space-y-0.5 mb-2">
        {asks?.reverse()?.map((ask, i) => (
          <div key={i} className="relative grid grid-cols-3 gap-2 px-1 py-1 rounded overflow-hidden">
            <div className="absolute inset-0 right-0 bg-red-500/10 rounded" style={{ width: `${(ask?.total / maxTotal) * 100}%`, marginLeft: "auto" }} />
            <span className="font-data text-xs text-red-400 relative z-10">${ask?.price?.toFixed(2)}</span>
            <span className="font-data text-xs text-foreground text-right relative z-10">{ask?.qty?.toLocaleString()}</span>
            <span className="font-data text-xs text-muted-foreground text-right relative z-10">${(ask?.total / 1000)?.toFixed(1)}K</span>
          </div>
        ))}
      </div>
      {/* Spread */}
      <div className="flex items-center justify-between px-1 py-2 border-y border-border my-2">
        <span className="font-caption text-xs text-muted-foreground">Spread</span>
        <span className="font-data text-sm font-bold text-primary">${stock?.price?.toFixed(2)}</span>
        <span className="font-caption text-xs text-muted-foreground">
          {((asks?.[0]?.price - bids?.[0]?.price) / stock?.price * 100)?.toFixed(3)}%
        </span>
      </div>
      {/* Bids */}
      <div className="space-y-0.5">
        {bids?.map((bid, i) => (
          <div key={i} className="relative grid grid-cols-3 gap-2 px-1 py-1 rounded overflow-hidden">
            <div className="absolute inset-0 bg-emerald-500/10 rounded" style={{ width: `${(bid?.total / maxTotal) * 100}%` }} />
            <span className="font-data text-xs text-emerald-400 relative z-10">${bid?.price?.toFixed(2)}</span>
            <span className="font-data text-xs text-foreground text-right relative z-10">{bid?.qty?.toLocaleString()}</span>
            <span className="font-data text-xs text-muted-foreground text-right relative z-10">${(bid?.total / 1000)?.toFixed(1)}K</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderBook;